import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { msalConfig } from "../../configs/MSAL.config";
import { InteractionStatus } from "@azure/msal-browser";

const ProtectedRoute = ({ component, path }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    instance.initialize();
    const checkAuth = async () => {
      try {
        await instance.loginRedirect({
          authority: process.env.REACT_APP_MSAL_AUTHORITY,
          scopes: msalConfig.auth.scopes,
        });
      } catch (error) {
        console.error(error);
      }
    };

    if (inProgress === InteractionStatus.None) {
      if (!isAuthenticated) {
        checkAuth();
      }
    }
  }, [inProgress, instance, isAuthenticated]);

  return <Route component={component} path={path} />;
};

export default ProtectedRoute;
